import { Button, Space, Tag, Typography } from "antd";
import { TableProps } from "antd/es/table";
import { BundleItem } from "../../../api/admin/webshop/bundles/BundleItem";
import { formatSgtDateTime } from "../promotions/promoDateUtils";

const { Text } = Typography;

export const getBundlesTableColumns = (
  onViewDetails: (record: BundleItem) => void,
): TableProps<BundleItem>["columns"] => [
  {
    title: "Promo Code",
    dataIndex: "promoCode",
    key: "promoCode",
    render: (promoCode: string) => <Text strong>{promoCode}</Text>,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Tiers",
    key: "tiers",
    render: (_: unknown, record: BundleItem) => {
      const summary = record.tierSummary;
      if (summary && summary.length > 0) {
        return summary.map((t) => t.discountLabel).join(" / ");
      }
      const tiers = record.tiers || [];
      if (tiers.length === 0) return "-";
      return tiers
        .map((t) => {
          const qty = t.minQty;
          const type = t.discount?.type;
          const value = t.discount?.value;
          if (type === "PERCENTAGE") return `${qty}+ : ${value}% off`;
          if (type === "FIXED_AMOUNT") return `${qty}+ : $${value} off`;
          return `${qty}+`;
        })
        .join(" / ");
    },
  },
  {
    title: "Start At",
    dataIndex: "startAt",
    key: "startAt",
    render: (startAt?: string | null) => formatSgtDateTime(startAt),
  },
  {
    title: "End At",
    dataIndex: "endAt",
    key: "endAt",
    render: (endAt?: string | null) =>
      endAt ? formatSgtDateTime(endAt) : "No expiry",
  },
  {
    title: "Live",
    dataIndex: "active",
    key: "active",
    render: (active: boolean | undefined, record: BundleItem) => {
      const isLive = active === true;
      return (
        <Space size={4}>
          <Tag color={isLive ? "green" : "default"}>
            {isLive ? "LIVE" : "NOT LIVE"}
          </Tag>
          <Tag color={record.status === "ACTIVE" ? "blue" : "red"}>
            {record.status || "INACTIVE"}
          </Tag>
        </Space>
      );
    },
  },
  {
    title: "Actions",
    key: "actions",
    render: (_: unknown, record: BundleItem) => (
      <Button type="primary" onClick={() => onViewDetails(record)}>
        View Details
      </Button>
    ),
  },
];
